import * as React from 'react';
import {Resume, Contact, School, Job, Publication, Experience} from './model';

export const ResumeView: React.FC<Resume> = (props) => (
  <div className="resume">
    <div className="contact-row">
      <ContactView {...props.contact}/>
      <h1 className='name'>
        <a href="resume.pdf" target='_blank'>{props.name}</a>
      </h1>
    </div>
    <StatementView statement={props.statement} />
    <EmploymentView jobs={props.jobs} />
    <EducationView education={props.education} />
    <PublicationsView publications={props.publications} />
  </div>
);

const ContactView: React.FC<Contact> = (props) => (
 <div className='contact'>
    <div className='address'>
    {
      props.address.split('\n').map((item, index) => <div key={index}>{item}</div>)
    }
    </div>
    <div className='email'>
      <a href={`mailto:${props.email}`}>{props.email}</a>
    </div>
    <div className='phone'>{props.phone}</div>
    <div>
      <a href={`https://${props.github}`}>{props.github}</a>
    </div>
    <div>
      <a href={`https://${props.blog}`}>{props.blog}</a>
    </div>
  </div>
);

const StatementView:React.FC<{statement: string}> = props => (
  <div className='statement'>
  {
    props.statement.split('\n').map((item, index) => <div key={index}>{item}</div>)
  }
  </div>
)

interface ListOfProps {
  hideAfter?: number;
  expandAll?: boolean;
  more?: string;
  children: React.ReactNode[];
}

const ListOf: React.FC<ListOfProps> = props => {
  const [hideAfter, setHideAfter] = React.useState(props.hideAfter || 0);

  const expand = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (props.expandAll) {
      setHideAfter(0);
    } else {
      setHideAfter(hideAfter + 1);
    }
  };

  const more = hideAfter != 0 && hideAfter < props.children.length;
  const visible = more ? props.children.slice(0, hideAfter) : props.children;
  const expando = more ? (
                      <div className='expando' onClick={e => expand(e)}>{props.more}</div>
                    ) : null;
  return (
      <div>
        {visible}
      {expando}
      </div>
    );
  }

const EducationView:React.FC<{education: School[]}> = props => (
  <div className='section education'>
    <h2>Education</h2>
    <ListOf>
      {props.education.map((el, i) => <EducationItem key={i} {...el}/>)}
    </ListOf>
  </div>
);

const EducationItem: React.FC<School> = props => (
  <div className='educationItem row'>
    <div className='institution'>
    {
      props.institution.split('\n').map((item, index) => <div key={index}>{item}</div>)
    }
    </div>
    <div className='dates'>{props.dates}</div>
    <div className='course'>{props.course}</div>
  </div>
);

const EmploymentView:React.FC<{jobs: Job[]}> = props => (
  <div className='section employment'>
    <h2>Professional Experience</h2>
    <ListOf hideAfter={3} more='more jobs &gt;&gt;'>
      {props.jobs.map((el, i) => <JobView key={i} {...el}/>)}
    </ListOf>
  </div>
);

const JobView:React.FC<Job> = props => (
  <div className='job'>
    <div className='row'>
      <div className='employer'>{props.employer}</div>
      <div className='date'>{props.from} – {props.to || 'Present'}</div>
    </div>
    <div className='row'>
      <div className='title'>{props.title}</div>
      <div className='technologies'>{props.technologies}</div>
    </div>
    <div className='row'>
      <div className='location'>{props.location}</div>
    </div>
    <div className='row jobExperience'>
        <ListOf hideAfter={2} more='more details &gt;&gt;&gt;'>
          {props.experience.map((el, i) => <ExperienceView key={i} {...el}/>)}
        </ListOf>
    </div>
  </div>
);

const ExperienceView:React.FC<Experience> = props => (
  <div className='experience'>
    <div className='subtitle'>{props.subtitle}</div>
    <div className='dates'>{props.dates}</div>
    {
      props.body.map((item, index) => <ExperienceItem key={index} data={item} /> )
    }
  </div>
);

const ExperienceItem:React.FC<{data:string}> = props => {
  const parts = props.data.split('\n');
  if (parts.length == 0) {
    return null;
  } else if (parts.length == 1) {
    return <div>{parts[0]}</div>;
  } else {
    return (
      <div>
        {parts[0]}
        <ul>
        {
          parts.slice(1).map((item, index) => <li key={index}>{item}</li>)
        }
        </ul>
      </div>
    );
  }
};

const PublicationsView:React.FC<{publications:Publication[]}> = props => (
  <div className='section publications'>
    <h2>Publications, Patents</h2>
    <ListOf
      hideAfter={1}
      more='show all'
      expandAll={true}>
        {props.publications.map((el, i) => <PublicationView key={i} {...el}/>)}
      </ListOf>
  </div>
);

const PublicationView:React.FC<Publication> = props => {
  const title = props.uri ?  (<a href={props.uri} target='_blank'>{props.title}</a>) : props.title;
  return (
    <div className='publication'>
      <div className='title'>{title}</div>
      <div className='publisher'>{props.publisher}</div>
      <div className='date'>{props.date}</div>
    </div>
  );
}
